import { CommonButton } from "@components/CommonButton";
import { Trans } from "react-i18next";
import { useLinkAccount } from "../hooks/useLinkAccount";
import { twMerge } from "tailwind-merge";

interface ReconnectButtonProps {
  className?: string;
}

export const ReconnectButton = ({ className }: ReconnectButtonProps) => {
  const go2OpenAuth = useLinkAccount();
  return (
    <CommonButton
      type="primary"
      size="small"
      className={twMerge("shrink-0 h-[28px]! rounded-[6px]! px-[10px]! py-[6px]!", className)}
      loading={go2OpenAuth.isPending()}
      onClick={go2OpenAuth}
    >
      <Trans>Reconnect</Trans>
    </CommonButton>
  );
};
